// import { HttpClientModule, HttpClient } from '@angular/common/http';
// import { Component } from '@angular/core';
// import { RouterOutlet } from '@angular/router';
// import { adminEnvironment } from '../environments/environment';
// import { SessionService } from './services/session-management.service';
// import { LocalStorageService } from './services/local-storage.service';

// @Component({
//   selector: 'app-root',
//   standalone: true,
//   imports: [RouterOutlet, HttpClientModule,],
//   templateUrl: './app.component.html',
//   styleUrl: './app.component.scss',
// })
// export class AppComponent {
//   title = 'toob-app-admin-frontend';

//   public http;
//   public showHeader = true;

//   constructor(http: HttpClient, private sessionService: SessionService, private storageService: LocalStorageService) {
//     this.http = http;
//   }
//   async ngOnInit(): Promise<void> {
//     localStorage.setItem(`is_admin`, 'true');
//     this.sessionService.initializeSession();
//     if (!this.storageService.getItem('customer_photo_loaded')) {
//       this.storageService.setItem('customer_photo_loaded', "true");
//     }
//     console.log(`Local Storage  ::  ${this.storageService.logAllItems()}`);
//     console.log(`adminEnvironment:`, adminEnvironment);
//   }

//   redirectToCognito() {
//     const cognitoUrl = `https://${adminEnvironment.aws.cognito.oauth.domain}/login?response_type=${adminEnvironment.aws.cognito.oauth.responseType}&client_id=${adminEnvironment.aws.cognito.userPoolWebClientId}&redirect_uri=${adminEnvironment.aws.cognito.oauth.redirectSignIn}`;
//     console.log(`cognitoUrl: ${cognitoUrl}`);
//     console.log(
//       `actual url: https://food-app.auth.ca-central-1.amazoncognito.com/login?client_id=2ovt4b3fao8k0u1j2a18tht8r6&response_type=code&scope=openid&redirect_uri=https://toob-ecommerce.com`
//     );

//     window.location.href = cognitoUrl;

//   }
// }


// admin.component.ts
import { Component } from '@angular/core';
import { NavigationCancel, NavigationEnd, NavigationError, NavigationStart, Router, RouterOutlet } from '@angular/router';
import { SideBarComponent } from "./components/admin/side-bar/side-bar.component";
import { CommonModule } from '@angular/common';
import { LoaderService } from './components/admin/service/loader.service';
import { AdminAuthService, AdminUserInfo } from './components/admin/service/admin-auth.service';
import { BannerComponent } from './components/admin/banner/banner.component';
import { IdleTimeoutService } from './components/admin/service/idle-timeout.service';
import { RbacService } from './components/admin/service/rbac.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, SideBarComponent, CommonModule, BannerComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  public admin_logged_in = false;
  sidebarIsCollapsed = false;
  public isLoading = false;
  adminUserInfo: AdminUserInfo = { userName: null, email: null, tenantId: null };
  tenantName: string | null = null;

  constructor(
    private loaderService: LoaderService,
    private router: Router,
    private authService: AdminAuthService,
    private idleService: IdleTimeoutService,
    private rbacService: RbacService
  ) { }

  ngOnInit() {
    this.idleService.startWatching();

    this.loaderService.loading$.subscribe(loading => {
      this.isLoading = loading;
    });

    this.authService.tenantName$.subscribe(name => {
      this.tenantName = name;
    });

    this.authService.adminUserInfo$.subscribe(userInfo => {
      this.adminUserInfo = userInfo;
      this.admin_logged_in = !!userInfo.userName;

      const token = localStorage.getItem('admin_access_token');
      if (token && this.admin_logged_in) {
        if (!localStorage.getItem('rbac_role')) {
          this.rbacService.loadRolesAndPolicies().catch(err => {
            console.error('Failed to load RBAC policies on app init:', err);
          });
        } else {
          this.rbacService.initializeFromStorage();
        }
      }
    });

    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        this.loaderService.show();
      }
      if (event instanceof NavigationEnd || event instanceof NavigationCancel || event instanceof NavigationError) {
        this.loaderService.hide();
      }
    });
  }


  onSidebarCollapsed(collapsed: boolean) {
    console.log('Sidebar collapsed state changed:', collapsed);
    this.sidebarIsCollapsed = collapsed;
  }

}
